'use strict';
window.jQuery = window.$ = require('jquery');
var processInclude = require('base/util');
require('base/main');
$(document).ready(function () {
    processInclude(require('./components/menu'));
    processInclude(require('./components/consentTracking'));
    processInclude(require('./login/login'));
    processInclude(require('./customSelect'));
    processInclude(require('./wishlist'));
    processInclude(require('./components/countrySelector'));
    processInclude(require('./product/wishlistHeart'));
    processInclude(require('./cart/cart'));
    processInclude(require('./components/miniCart'));
    processInclude(require('./search/search'));
    processInclude(require('./components/collapsibleItem'));
    processInclude(require('./components/customToolTip'));
});
require('./commonScript');
require('./product/initSlick');
require('./product/pdpZoom');
require('./pincodeMapping');
require('./product/pdpCustom');
require('./cart/sfmcTrackCart');
require('./wishlist/sfmcWishlistTrack');
require('./product/productVideo');
require('./components/gtm-components');
require('./components/gtm-components-footer');
require('buyNow/buyNow');
require('../../../../../../goKwik/gokwik_checkout/cartridge/client/default/js/gokwikcheckout');
